import React from "react";
import { Modal, Button } from "react-bootstrap";
import { FiX } from "react-icons/fi";
import certificate from "../../../../../assets/img/reports/certificate.png"
export default function ViewCertificateModal({ show, onHide, data }) {
  if (!data) return null;

  return (
    <Modal show={show} onHide={onHide} centered size="lg">

      {/* HEADER */}
      <div
        style={{
          padding: "15px 20px",
          borderBottom: "1px solid #e5e7eb",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <h5 style={{ fontWeight: 600 }}>View Certificate</h5>

        <div
          onClick={onHide}
          style={{
            width: 30,
            height: 30,
            borderRadius: "50%",
            background: "#f3f4f6",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
          }}
        >
          <FiX />
        </div>
      </div>

      {/* BODY */}
      <Modal.Body style={{ textAlign: "center" }}>
        <img
          src={certificate}
          alt="certificate"
          style={{
            width: "100%",
            borderRadius: 6,
          }}
        />
      </Modal.Body>

      {/* FOOTER */}
      <div
        style={{
          padding: 15,
          borderTop: "1px solid #e5e7eb",
          display: "flex",
          justifyContent: "flex-end",
        }}
      >
        <Button
          onClick={() => {
            const link = document.createElement("a");
            link.href = data.certificate;
            link.download = "certificate.jpg";
            link.click();
          }}
          style={{
            background: "#f97316",
            border: "none",
          }}
        >
          Download
        </Button>
      </div>
    </Modal>
  );
}